import { render, staticRenderFns } from "./PDFProductos.vue?vue&type=template&id=33162767&"
import script from "./PDFProductos.vue?vue&type=script&lang=js&"
export * from "./PDFProductos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports